<template>
  <div>
    <identity-verification-form
      :form-model="formModel"
      :person-title="locale.partners.thePartner"
      :view-mode="loading"
      :manager-social-id-required="false"
      :request-owner-type-id="requestOwnerTypeId"
      :main-request-details-types="mainRequestDetailsTypesEnum.partners"
      :is-edit-mode="isEditMode"
      :is-gov-sub-request="isGovSubRequest"
      @isIdentityVerified="$emit('isIdentityVerified', $event)"
    >
      <template slot="partner">
        <v-row>
          <v-col
            cols="12"
            lg="3"
          >
            <naj-input
              :type-id="formFieldType.text"
              :label="locale.bankruptDebts.email"
              :value.sync="formModel.email"
              :validates="`email|no_gov_email`"
              :disabled="isViewMode || isEditMode"
            ></naj-input>
          </v-col>
          <v-col
            cols="12"
            lg="3"
          >
            <naj-input
              :type-id="formFieldType.selectbox"
              :label="locale.bankruptDebts.countryId"
              :value.sync="formModel.countryId"
              :value-name.sync="formModel.countryName"
              :items="countries"
              item-text="name"
              item-value="id"
              validates="required"
              :disabled="!countries.length || isViewMode || isEditMode"
              @change="countryChanged"
            ></naj-input>
          </v-col>
          <v-col
            v-if="(cities || []).length != 0"
            cols="12"
            lg="3"
          >
            <naj-input
              :type-id="formFieldType.selectbox"
              :label="locale.bankruptDebts.cityId"
              :value.sync="formModel.cityId"
              :value-name.sync="formModel.cityName"
              :items="cities"
              item-text="name"
              item-value="id"
              validates="required"
              :disabled="isViewMode || isEditMode"
            ></naj-input>
          </v-col>
          <v-col
            v-else
            cols="12"
            lg="3"
          >
            <naj-input
              :type-id="formFieldType.text"
              :label="locale.bankruptDebts.cityId"
              :value.sync="formModel.cityName"
              :disabled="isViewMode || isEditMode"
              validates="required"
            ></naj-input>
          </v-col>
        </v-row>
      </template>
    </identity-verification-form>
    <naj-dynamic-form
      :form-model="formModel"
      :form-fields="formFields"
      :view-mode="loading"
    ></naj-dynamic-form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapActions, mapGetters } = createNamespacedHelpers('BankruptcyModule');
import IdentityVerificationForm from '../../../identity-verification-form.vue';
import { mainRequestDetailsTypesEnum } from '@/modules/bankruptcy/helpers/enum';

export default {
  inject: ['$validator'],
  components: { IdentityVerificationForm },
  props: {
    formModel: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    isEditMode: {
      type: Boolean,
      required: false,
    },
    requestOwnerTypeId: {
      type: Number,
      required: false,
      default: null,
    },
    isGovSubRequest: {
      type: Boolean,
      required: false,
      default: () => false,
    }
  },
  data() {
    return {
      locale: this.local.bankruptcy.requestDetails,
      mainRequestDetailsTypesEnum,
    };
  },
  computed: {
    ...mapState(['countries', 'countryCities']),
    ...mapGetters([
      'isViewMode',
      'isNewMode',
      'isNotCompleted',
    ]),
    cities() {
      return this.countryCities[this.formModel.countryId];
    },
    formFields() {
      return [
        {
          typeId: this.formFieldType.text,
          name: 'share',
          label: this.locale.partners.share,
          columnSize: 12,
          properties: JSON.stringify({
            validations: {
              required: true,
              decimal: 2,
              min_value: 0.1,
              max_value: 100,
            },
          }),
        },
      ];
    },
  },
  watch: {
    'formModel.countryId'(newValue) {
      this.getCountryCities(newValue);
    },
  },
  created() {
    this.getCountries();
  },
  methods: {
    ...mapActions(['getCountries', 'getCountryCities']),
    countryChanged(value) {
      if (value) {
        this.getCountryCities(value);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
